import type { Page, RateCardListQuery } from '@chukua/common';
import { Table, type TableColumnsType } from 'antd';
import { SearchX } from 'lucide-react';
import { CustomerSearchSelect } from '../../customers/public/CustomerSearchSelect';
import { EmptyState } from '../../../shared/components/EmptyState';
import type { ListQueryControls } from '../../../shared/hooks/use-list-query';
import type { RateCardView } from '../rate-cards.api';

interface RateCardsTableProps {
  page: Page<RateCardView>;
  columns: TableColumnsType<RateCardView>;
  list: ListQueryControls<RateCardListQuery>;
  isRefreshing: boolean;
}

/**
 * The customer picker is the search: a card has no text of its own, and its name is the customer's, which lives in
 * another module, so the list filters by customer id rather than matching a name here.
 */
export function RateCardsTable({ page, columns, list, isRefreshing }: RateCardsTableProps) {
  const isFiltered = list.isFiltered || Boolean(list.query.customerId);

  return (
    <div className="flex flex-col gap-4">
      <div className="w-full md:max-w-sm">
        <CustomerSearchSelect allowClear value={list.query.customerId} onChange={(customerId) => list.setQuery({ customerId })} />
      </div>
      <Table
        rowKey="id"
        dataSource={page.items}
        columns={columns}
        loading={isRefreshing}
        scroll={{ x: 'max-content' }}
        locale={isFiltered ? { emptyText: <NoMatchingRateCards /> } : undefined}
        {...list.tableProps<RateCardView>(page.total)}
      />
    </div>
  );
}

function NoMatchingRateCards() {
  return <EmptyState icon={SearchX} title="No matching rate cards" description="No rate cards match this customer or these filters." />;
}
